import React from 'react';
import { dispatch } from '@rematch/core';
import { Card, Icon, Checkbox, Image, Popup } from 'semantic-ui-react';
import FilterActivityModal from './../modals/FilterActivity';
import ActivityCard from './ActivityCardNew';
import ResizeDetector from 'react-resize-detector';
import aciveFilterIcon from './../../../../../images/grafix-icon/icon-check-circle.svg';

class ProgressCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.parentRef = React.createRef();
        this.state = {
            open: false,
            initiativeComplete: false
        }
    }

    componentDidMount() {
        let payload = {
            organizationId: this.props.match.params.workspaceId,
            initiativeId: this.props.match.params.initiativeId
        }
        dispatch.initiatives.getAssociatedTeam(payload)
        dispatch.initiatives.setSelectedActivityData({})
    }

    handleRaciChange = (event, data) => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        dispatch.organizationUnit.showResourecePane(null)
        if (data.checked) {
            if (data.label === 'All' || data.label === 'Initiative Progress') {
                this.props.raciFilterProperties.raciAllChecked = true;
                this.props.raciFilterProperties.myProgressChecked = false;
                this.props.raciFilterProperties.accountable = false;
                this.props.raciFilterProperties.responsible = false;
                this.props.raciFilterProperties.consulted = false;
                this.props.raciFilterProperties.informed = false;
            }
            if (data.label === 'My Progress') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.myProgressChecked = true;
                this.props.raciFilterProperties.accountable = false;
                this.props.raciFilterProperties.responsible = false;
                this.props.raciFilterProperties.consulted = false;
                this.props.raciFilterProperties.informed = false;
            }
            if (data.label === 'Accountable') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.myProgressChecked = false;
                this.props.raciFilterProperties.accountable = true;
            }
            if (data.label === 'Responsible') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.myProgressChecked = false;
                this.props.raciFilterProperties.responsible = true;
            }
            if (data.label === 'Consulted') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.myProgressChecked = false;
                this.props.raciFilterProperties.consulted = true;
            }
            if (data.label === 'Informed') {
                this.props.raciFilterProperties.raciAllChecked = false;
                this.props.raciFilterProperties.myProgressChecked = false;
                this.props.raciFilterProperties.informed = true;
            }
        } else {
            if (data.label === 'All' || data.label === 'Initiative Progress') {
                this.props.raciFilterProperties.raciAllChecked = false;
            }
            if (data.label === 'My Progress') {
                this.props.raciFilterProperties.myProgressChecked = false;
            }
            if (data.label === 'Accountable') {
                this.props.raciFilterProperties.accountable = false;
            }
            if (data.label === 'Responsible') {
                this.props.raciFilterProperties.responsible = false;
            }
            if (data.label === 'Consulted') {
                this.props.raciFilterProperties.consulted = false;
            }
            if (data.label === 'Informed') {
                this.props.raciFilterProperties.informed = false;
            }
        }
        if (!this.props.raciFilterProperties.accountable &&
            !this.props.raciFilterProperties.responsible &&
            !this.props.raciFilterProperties.consulted &&
            !this.props.raciFilterProperties.informed &&
            !this.props.raciFilterProperties.myProgressChecked) {
            this.props.raciFilterProperties.raciAllChecked = true;
        }

        dispatch.initiatives.setRACIFilterProperties(this.props.raciFilterProperties);

        if (this.props.activeTab === 'myactivities') {
            dispatch.initiatives.setPageStatus(this.props.match.params.initiativeStatus);
            let payload = {
                organizationId: this.props.match.params.workspaceId,
                userId: this.props.match.params.userId ? this.props.match.params.userId : this.props.user._id,
                teamId: this.props.match.params.teamId,
            }
            dispatch.initiatives.getInitiativeActivitiesForMember(payload);
        } else {
            let payload = {
                initiativeId: this.props.match.params.initiativeId,
                accountUserId: this.props.user._id
            }
            dispatch.initiatives.getAllActivities(payload);
        }
    }

    filterClick = (open) => {
        this.setState({
            prevAdvancedFilterProperties: Object.assign({}, this.props.advancedFilterProperties),
            prevRaciFilterProperties: Object.assign({}, this.props.raciFilterProperties)
        })
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        // dispatch.organizationUnit.showResourecePane(null)
        this.setState({ open: open })
    }

    closeFilterModal = () => {
        dispatch.initiatives.setAdvancedFilterProperties(Object.assign({}, this.state.prevAdvancedFilterProperties));
        dispatch.initiatives.setRACIFilterProperties(Object.assign({}, this.state.prevRaciFilterProperties));
        this.setState({ open: false })
    }

    onClickHandle = (e, parentId, rowNo) => {
        e.stopPropagation();
    }

    render() {
        let initiativesListForMemberFilter = []
        if (this.props.activeTab === 'myactivities') {
            if (this.props.initiativeCountDataForMember && this.props.initiativeCountDataForMember.activeInitiatives && this.props.initiativeCountDataForMember.completedInitiatives) {
                initiativesListForMemberFilter = [...this.props.initiativeCountDataForMember.activeInitiatives, ...this.props.initiativeCountDataForMember.completedInitiatives]
            }
        }

        let activityData = this.props.activityNodes;
        let notstarted = [], inProgress = [], delayed = [], issue = [], completed = [], cancelled = [];
        if (activityData) {
            for (let i = 0; i < activityData.length; i++) {
                if ((activityData[i].runStatus === -1 || activityData[i].runStatus === 0) && (!activityData[i].isDelayedToEnd) && (!activityData[i].issueFlag)) {
                    notstarted.push(activityData[i]);
                }
                if (activityData[i].runStatus === 1 && !activityData[i].isDelayedToEnd && (!activityData[i].isDelayedToStart || activityData[i].isDelayedToStart) && !activityData[i].issueFlag) {
                    inProgress.push(activityData[i]);
                }
                if ((activityData[i].runStatus === -1 || activityData[i].runStatus === 0 || activityData[i].runStatus === 1) && activityData[i].isDelayedToEnd && !activityData[i].issueFlag) {
                    delayed.push(activityData[i]);
                }
                if ((activityData[i].runStatus !== 2) && activityData[i].issueFlag) {
                    issue.push(activityData[i]);
                }
                if (activityData[i].runStatus === 2) {
                    completed.push(activityData[i]);
                }
                if (activityData[i].runStatus === 3) {
                    cancelled.push(activityData[i]);
                }
            }
        }



        /**
         * Sorting the activities data to show the activities on top which we can start (start button) 
         */
        if (notstarted && notstarted.length > 0) {
            notstarted.sort(function (a, b) {
                if (a.runStatus > b.runStatus) return -1;
                if (a.runStatus < b.runStatus) return 1;
                return 0;
            });
        }

        let dataStructure = [
            {
                id: "notstarted",
                name: "Not Started",
                count: notstarted && notstarted.length,
                data: notstarted,
                bgColor: "circle-gray"
            },
            {
                id: "inprogress",
                name: "In Progress",
                count: inProgress && inProgress.length,
                data: inProgress,
                bgColor: "circle-green"
            },
            {
                id: "delayed",
                name: "Delayed",
                count: delayed && delayed.length,
                data: delayed,
                bgColor: "circle-orange"
            },
            {
                id: "issue",
                name: "Issue",
                count: issue && issue.length,
                data: issue,
                bgColor: "circle-red"
            },
            {
                id: "completed",
                name: "Completed",
                count: completed && completed.length,
                data: completed,
                bgColor: "circle-blue"
            },
            {
                id: "cancelled",
                name: "Cancelled",
                count: cancelled && cancelled.length,
                data: cancelled,
                bgColor: "circle-navyBlue"
            }
        ]
        let isFilterApplied = (this.props.raciFilterProperties &&
            (this.props.raciFilterProperties.accountable ||
                this.props.raciFilterProperties.responsible ||
                this.props.raciFilterProperties.consulted ||
                this.props.raciFilterProperties.informed)) ||
            (this.props.advancedFilterProperties &&
                (this.props.advancedFilterProperties.roles.length > 0 ||
                    this.props.advancedFilterProperties.stateActiveChecked ||
                    this.props.advancedFilterProperties.stateOnHoldChecked ||
                    this.props.advancedFilterProperties.statusNotStartedChecked ||
                    this.props.advancedFilterProperties.statusCompletedChecked ||
                    this.props.advancedFilterProperties.statusIssueChecked ||
                    this.props.advancedFilterProperties.statusInProgressChecked ||
                    this.props.advancedFilterProperties.statusDelayedChecked ||
                    this.props.advancedFilterProperties.showAllRoles ||
                    this.props.advancedFilterProperties.serarchedRolesAvailable ||
                    this.props.advancedFilterProperties.selectedUsers.length > 0)) ? true
            : false


        let windowDimension = this.props.componentDesignerDimension;

        let progressHeight = this.props.noInitiativeMessage ? (windowDimension.windowHeight - (windowDimension.height + 50)) : (windowDimension.windowHeight - windowDimension.height)

        return (
            <div className="w_100 display-grid">
                <Card className="progressDetail">
                    <Card.Content className="header_content " onMouseEnter={() => dispatch.app.setHelpContext("Role Selection Bar")}>
                        <Card.Header>
                            {this.props.activeTab === "myactivities" ?
                                <div style={{ padding: "10px 0px", margin: "0 0 0 10px" }}>
                                    <Checkbox className="checkboxStyled labelClick" label='All' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.raciAllChecked} />
                                    <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.allCount})</span>
                                </div>
                                :
                                <div style={{ padding: "10px 0px", margin: "0 0 0 10px" }}>
                                    <Checkbox className="checkboxStyled labelClick" label='Initiative Progress' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.raciAllChecked} />
                                    <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.allCount})</span>
                                </div>
                                // <strong className="pad_10"> Initiative Progress </strong>
                            }

                            <div className="verticalDivider" >  &nbsp; </div>
                            {this.props.activeTab === "myactivities" ? "" :
                                // <strong className="pad_10"> My Progress </strong>
                                <div style={{ padding: "10px 0px", margin: "0 10px 0 10px" }}>
                                    <Checkbox className="checkboxStyled labelClick" label='My Progress' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.myProgressChecked} />
                                    <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.myProgressCount})</span>
                                </div>
                            }
                            <div style={{ padding: "10px 10px 10px 0px" }}>
                                <Checkbox className="checkboxStyled labelClick" label='Accountable' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.accountable} />
                                <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.accountableCount})</span>
                            </div>
                            <div style={{ padding: "10px 10px 10px 0px" }}>
                                <Checkbox className="checkboxStyled labelClick" label='Responsible' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.responsible} />
                                <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.responsibleCount})</span>
                            </div>
                            <div style={{ padding: "10px 10px 10px 0px" }}>
                                <Checkbox className="checkboxStyled labelClick" label='Consulted' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.consulted} />
                                <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.consultedCount})</span>
                            </div>
                            <div style={{ padding: "10px 10px 10px 0px" }}>
                                <Checkbox className="checkboxStyled labelClick" label='Informed' onChange={(event, data) => this.handleRaciChange(event, data)} checked={this.props.raciFilterProperties.informed} />
                                <span style={{ color: 'white', fontWeight: 100 }}>({this.props.raciCount && this.props.raciCount.informedCount})</span>
                            </div>
                            {
                                this.props.activeTab !== "myactivities" ?
                                    isFilterApplied ?
                                        <div className='pull-right pad_12 activeFilter' >
                                            <Popup
                                                hoverable
                                                className="popupStyled "
                                                inverted
                                                trigger={
                                                    <span>
                                                        <Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right" />
                                                        <Image size='mini' src={aciveFilterIcon} onClick={() => this.filterClick(true)} className="pull-right " style={{ position: "absolute", right: '8px', top: '8px', width: '10px', color: 'white' }} />
                                                    </span>
                                                }
                                                content="Filter"
                                            />

                                        </div> :
                                        <div className='pull-right pad_12' >

                                            <Popup
                                                hoverable
                                                className="popupStyled "
                                                inverted
                                                trigger={<Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right" />}
                                                content="Filter"
                                            />



                                        </div> : ''
                            }
                            {this.props.activeTab !== "myactivities" && <div className="verticalDivider pull-right" style={{ margin: '0px' }}>  &nbsp; </div>}
                            {
                                this.props.activeTab === "myactivities" ?
                                    isFilterApplied ?
                                        <div className='pull-right activeFilter' style={{ padding: '12px 0' }}>
                                            <Popup
                                                hoverable
                                                className="popupStyled "
                                                inverted
                                                trigger={
                                                    <span>
                                                        <Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right " style={{ margin: "0px 15px 0px 10px" }} />
                                                        <Image size='mini' src={aciveFilterIcon} onClick={() => this.filterClick(true)} className="pull-right " style={{ position: "absolute", right: '8px', top: '8px', width: '10px', color: 'white' }} />
                                                    </span>
                                                }
                                                content="Filter"
                                            />

                                        </div> :
                                        <div className='pull-right' style={{ padding: '12px 0' }}>
                                            <Popup
                                                hoverable
                                                className="popupStyled "
                                                inverted
                                                trigger={<Icon link name="sliders horizontal" onClick={() => this.filterClick(true)} className="pull-right " style={{ margin: "0px 15px 0px 10px" }} />}
                                                content="Filter"
                                            />
                                        </div> : ''
                            }
                            {
                                this.props.activeTab === "myactivities" ?
                                    <div className="initiaitveCount" >
                                        Team member in  <div className="circularCount circle-white" style={{ padding: "2px 5px 0", float: 'none' }}>
                                            {
                                                this.props.initiativeCountDataForMember && this.props.initiativeCountDataForMember ?
                                                    this.props.initiativeCountDataForMember.activeInitiatives.length
                                                    + this.props.initiativeCountDataForMember.completedInitiatives.length
                                                    : 0
                                            }
                                        </div> Initiatives
                                    </div> : ''
                            }

                        </Card.Header>
                    </Card.Content>
                    <Card.Content className="Detailed_content" >
                        <div className={this.props.match.params.myactivities === "myactivities" ? "slideContainerWithFiveColumn" : "slideContainer"}>
                            {dataStructure && dataStructure
                                .filter(f => { return this.props.match.params.myactivities === "myactivities" ? f.name !== 'Cancelled' : f })
                                .map((columnData, i) => {


                                    return <div key={i} className={this.props.match.params.myactivities === "myactivities" ? "progressActivitieswithFiveColumn" : "progressActivities"} >
                                        <div className="progress-column"> {columnData.name}
                                            <div className={`circularCount ${columnData.bgColor}`} > {columnData.count} </div>
                                        </div>
                                        <div id={columnData.id}
                                            ref={this.parentRef}
                                            style={{
                                                height: progressHeight ? progressHeight - (this.props.activeTab === "myactivities" ? 200 : 260) : 260,
                                                overflow: "auto",
                                                overflowX: 'hidden',
                                                margin: "2px 0"
                                            }}>
                                            {columnData && columnData.data && columnData.data.map((item, index) => {
                                                return <div onClick={(e) => this.onClickHandle(e, columnData.id, index)} key={index} style={{ margin: "5px", position: "relative" }}>
                                                    {/* <ActivityCard
                                                    activityData={item}
                                                    selectedActivityData={this.props.selectedActivityData}
                                                    activityRACIUsers={this.props.activityRACIUsers}
                                                    // setPosition={this.setPosition}
                                                    // laneKey={columnData.id}
                                                    index={index}
                                                    user={this.props.user} {...this.props}
                                                /> */}
                                                    <ActivityCard
                                                        type="activity"
                                                        activityData={item}
                                                        selectedActivityData={this.props.selectedActivityData}
                                                        activityRACIUsers={this.props.activityRACIUsers}
                                                        selectedDataById={this.props.selectedDataById}
                                                        selectedOrganisation={this.props.selectedOrganisation}
                                                        index={index}
                                                        user={this.props.user}
                                                        {...this.props}
                                                    />
                                                </div>
                                            })}
                                            <ResizeDetector handleWidth handleHeight onResize={this.onResize} targetDomEl={this.parentRef.current} />
                                        </div>
                                    </div>
                                })}
                        </div>
                    </Card.Content>
                    <FilterActivityModal
                        initiativeId={this.props.match.params.initiativeId}
                        associatedTeams={this.props.associatedTeams}
                        raciFilterProperties={this.props.raciFilterProperties}
                        advancedFilterProperties={this.props.advancedFilterProperties}
                        accountUserId={this.props.user._id}
                        activeTab={this.props.activeTab}
                        open={this.state.open}
                        filterClick={this.filterClick}
                        closeFilterModal={this.closeFilterModal}
                        initiativesList={initiativesListForMemberFilter}
                        organizationId={this.props.match.params.workspaceId}
                        user={this.props.user}
                        teamId={this.props.match.params.teamId}
                        userId={this.props.match.params.userId ? this.props.match.params.userId : this.props.user._id}
                    />
                </Card >
            </div>
        )
    }
}



export default ProgressCard;
